<template>
    <div class="hello">
        <h1>Thanks For Your Donation!</h1>
       On behalf of my family, thank you for your generous donation.  Your support allows us to spend more time improving this site.

        <div class="row">
            <img src="../assets/thankYouDance.gif">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Thanks',
        data () {
            return {
            }
        },
        mounted() {
            this.$ga.event('Donate', "PaypalFinished", "Website", 1000);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/ThankYouForDonating.vue